var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-deactived",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 6,
    viewBox: "0 0 12.8 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Hide",
    d: "M2.234,6.324a.6.6,0,0,1,.84.108l0,0,.016.019c.016.019.041.049.077.088a4.672,4.672,0,0,0,.34.333,6.484,6.484,0,0,0,1.428.953A7.718,7.718,0,0,0,8.4,8.6a7.718,7.718,0,0,0,3.462-.772,6.483,6.483,0,0,0,1.428-.953,4.687,4.687,0,0,0,.34-.333c.036-.039.062-.069.078-.088l.016-.019,0,0a.6.6,0,0,1,.95.733h0v0l0,0-.01.012-.032.039c-.027.032-.064.075-.113.129a5.853,5.853,0,0,1-.428.419,7.513,7.513,0,0,1-1.159.842l.977,1.913a.6.6,0,1,1-1.069.546l-.983-1.926A8.913,8.913,0,0,1,9,9.782V11.6a.6.6,0,0,1-1.2,0V9.782a8.914,8.914,0,0,1-2.854-.635l-.983,1.926a.6.6,0,0,1-1.069-.546l.977-1.913a7.511,7.511,0,0,1-1.159-.842,5.864,5.864,0,0,1-.428-.419c-.049-.053-.086-.1-.113-.129l-.032-.039-.01-.012,0,0v0h0A.6.6,0,0,1,2.234,6.324Z",
    transform: "translate(-2 -6.2)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactived);
export default __webpack_public_path__ + "static/media/deactived.100364d340658a6a56d8a73c47963d57.svg";
export { ForwardRef as ReactComponent };